;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"5befa1b3a4490d35be7c84c2eb9a44b423bfcafa"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from '@sentry/nextjs';

import { CORE_ERROR_PATTERNS, createBeforeSend } from '@zep/sentry';

import baseOptions from '../../sentry.base.config';

Sentry.init({
  ...baseOptions,
  beforeSend: createBeforeSend({
    ignorePatterns: [...CORE_ERROR_PATTERNS],
  }),
});
